import { render, staticRenderFns } from "./ResetPasswordWithCode.vue?vue&type=template&id=1c3e495e&scoped=true&"
import script from "./ResetPasswordWithCode.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordWithCode.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordWithCode.vue?vue&type=style&index=0&id=1c3e495e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e495e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3e495e')) {
      api.createRecord('1c3e495e', component.options)
    } else {
      api.reload('1c3e495e', component.options)
    }
    module.hot.accept("./ResetPasswordWithCode.vue?vue&type=template&id=1c3e495e&scoped=true&", function () {
      api.rerender('1c3e495e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/ResetPasswordWithCode.vue"
export default component.exports